import React, { useState } from 'react';
import { isEmpty } from 'lodash/lang';

import DatePicker from '../../../../../../common/data-entry/DatePicker';
import ModalBoxes from '../../../../../../common/feedback/ModalBoxes/ModalBoxes';
import Button from '../../../../../../common/general/Button';
import ButtonGroup from '../../../../../../common/general/ButtonGroup';
import { isTodayOrAfter } from '../../../../../../services/date/validators';

import './PublishModal.scss';

export default function PublishModal({ onSave, modalBox }) {
  const [publishDate, setPublishDate] = useState('');
  const [errorMsg, setErrorMsg] = useState(null);

  return (
    <>
      <ModalBoxes.Body>
        <DatePicker
          label="Date"
          value={publishDate}
          onChange={dt => {
            if (dt) {
              setPublishDate(dt);
              setErrorMsg('');
            }
          }}
          isValidDate={isTodayOrAfter}
          required={true}
          validationMessage={errorMsg}
        />
      </ModalBoxes.Body>
      <ModalBoxes.Footer>
        <ButtonGroup>
          <Button priority="medium" onClick={modalBox.close}>
            Cancel
          </Button>
          <Button
            onClick={() => {
              if (!isEmpty(publishDate)) {
                return onSave && onSave({ publishDate, errorMsg });
              }
              setErrorMsg('Select publish date.');
            }}
          >
            Save
          </Button>
        </ButtonGroup>
      </ModalBoxes.Footer>
    </>
  );
}

PublishModal.className = 'publish-modal';
PublishModal.size = 'w350';
